import createReactClass from "create-react-class";

export default function ({ tools, InputField }) {

  const TextField = createReactClass({
    render() {
      var { state, config } = this.props.field;

      return <div className="lz-input-wrapper" >
        <label htmlFor={tools.uniqueId(config.id)}>{config.label}</label>
        <span className="lz-extratext">{config.tinyLabel}</span>
        <div className={`lz-input ${this.props.errorClass} ${(config.style && config.style.lz_input) || ""}`} >
          <div className={this.props.spinnerClass} >
            <i className="fa fa-spinner fa-spin"></i>
          </div>
          <div className="lz-checkmark">
            <i className="fa fa-check"></i>
          </div>
          <InputField config={config} state={state} onUpdate={this.props.onUpdate} index={this.props.index} />
          <span className="lz-input-bar"></span>
        </div>
        <div className="lz-slider-wrapper">
          <div className="lz-slider"  >
            <div className="lz-slider-status" style={{ "width": this.state.sliderPosition }} ></div>
            <table>
              <tbody>
                <tr>
                  <td className="lz-slider-padding"></td>
                  <td className="lz-slider-path" ref={el => this.element = el} onMouseDown={this.moveSlider} onTouchStart={this.moveSlider} >
                    <div className="lz-slider-handle" style={{ "left": this.state.sliderPosition }} onTouchStart={this.startDrag} onMouseDown={this.startDrag} ></div>
                  </td>
                  <td className="lz-slider-padding"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {this.props.errors}
      </div>;
    },
    componentWillReceiveProps(props) {
      var { config, state } = props.field;
      var { notHigher, max, min } = config;

      if (typeof notHigher !== 'undefined') {
        max = props.globalState[notHigher]
      }

      var size = sizeFromValue(state.value, {
        max, min
      });

      this.setState({
        sliderPosition: size
      });
    },
    componentDidUpdate(prevProps) {
      const { followIfLower } = this.props.field.config

      if (typeof followIfLower !== 'undefined') {

        const followIfLowerValue = this.props.globalState[followIfLower]

        if (Number(followIfLowerValue) < Number(this.props.field.state.value)) {
          this.props.field.state.value = followIfLowerValue

          this.state.sliderPosition = sizeFromValue(followIfLowerValue, this.props.field.config)

          this.props.onUpdate()
          this.forceUpdate()
        }

      }
    },
    getInitialState() {
      var { state, config } = this.props.field;

      var { notHigher, max, min } = config;

      if (typeof notHigher !== 'undefined') {
        max = this.props.globalState[notHigher]
      }

      return {
        sliderPosition: sizeFromValue(state.value, { max, min })
      };
    },
    element: null,
    startDrag, moveSlider, stopDrag, focus,
  });

  return {
    html: TextField,
    config: {
      "format": "integer",
      "min": 0,
      "max": 100,
      "behaviour": "text-input",
      "validators": ["mandatory", "onlyDigits"]
    }
  };
};



function listeners() {
  return [
    ["mousemove", this.moveSlider],
    ["touchmove", this.moveSlider],
    ["mouseup", this.stopDrag],
    ["mouseleave", this.stopDrag],
    ["touchend", this.stopDrag],
    ["dragend", this.stopDrag],
  ];
}

function startDrag() {
  listeners.bind(this)().forEach(([key, listener]) => {
    document.body.addEventListener(key, listener);
  });
}

function stopDrag() {
  listeners.bind(this)().forEach(([key, listener]) => {
    document.body.removeEventListener(key, listener);
  });
}


function moveSlider(event) {
  event.preventDefault();

  var { state, config } = this.props.field;
  let { notHigher, max, min, plusSign, largeStep, stepDivider } = this.props.field.config

  if (typeof largeStep !== 'undefined' && typeof stepDivider !== 'undefined') {
    state.value < stepDivider ? config.step = 1 : config.step = largeStep
  }
  
  
  if (typeof notHigher !== 'undefined') {
    config.max = this.props.globalState[notHigher]
  }
  
  var value = valueFromEvent(this.element, config, normalizeEvent(event));
  var rounded = forceValueToSpec(value, config);
  
  if (plusSign && value === max) {
    config.suffix[0] !== "+" ? config.suffix = "+ " + config.suffix : null
  } else {
    typeof config.suffix.split(" ")[1] != 'undefined' ? config.suffix = config.suffix.split(" ")[1] : null
  }

  state.value = String(rounded);
  this.state.sliderPosition = sizeFromValue(value, {
    max, min
  })

  this.forceUpdate()

  state.status = "blurred";
  if (this.props.onUpdate) this.props.onUpdate();
}

function sizeFromValue(value, { max, min }) {
  var size = (value - min) / (max - min) * 100;
  return withinBoundaries(size, 0, 100) + "%";
}

function orEndpoint(value, stepped, step, min, max) {
  var distanceToEnds = [value - min, stepped - min, max - value, max - stepped];
  var closestDistance = Math.min.apply(null, distanceToEnds);

  if (stepped - step < min) return min + closestDistance;
  else if (stepped + step > max) return max - closestDistance;
  else return stepped;
}

function forceValueToSpec(value, { format, step, min, max }) {
  var rounded = format === "integer" ? Math.round(value) : value;
  var stepped = step * Math.round(rounded / step);
  return orEndpoint(rounded, stepped, step, min, max);
}

function normalizeEvent(event) {
  return {
    clientX: event.clientX || event.targetTouches[0].clientX
  };
}

function valueFromEvent(element, config, event) {
  var { max, min } = config;
  var size = element.getBoundingClientRect();
  var position = (event.clientX - size.left) / (size.right - size.left);
  var value = position * (max - min) + min;
  return withinBoundaries(value, min, max);
}


function withinBoundaries(value, min, max) {
  return Math.min(Math.max(value, min), max);
}


function notUndefined(value, fallback) {
  return value !== undefined ? value : fallback;
}